function random(from, to) {
    return Math.random() * (to - from) + from;
}

export function generateVerticalAnimationKeyframes() {
    return {
        "0": {
            "transform": "translateY(0) rotate(0deg)",
        },
        "100%": {
            "transform": `translateY(${random(30,60)}px) rotate(-${random(5,15)}deg)`,
        }
    };
}

// Sprites face left. Unflipped fish swim right-to-left; LTR swims are flipped
// with the CSS scale property (daily clips honor that, not transform).
export function swimFacingScale(direction) {
    return direction === "right" ? "-1 1" : "1 1";
}

// One CSS timeline goes across and back. The daily generator plays 0–100%
// and does not run animationend, so the return trip must live in keyframes.
export function generateHorizontalAnimationKeyframes(width, direction) {
    return {
        "0%": {
            [direction]: "100%",
        },
        "50%": {
            [direction]: `-${width}px`,
        },
        "51%": {
            [direction]: `-${width}px`,
        },
        "100%": {
            [direction]: `calc(100% + ${width}px)`,
        },
    };
}

// Flip heading at the same 51% mark as the U-turn, using `scale` (not transform).
export function generateFacingScaleKeyframes(direction) {
    const outbound = swimFacingScale(direction);
    const inbound = swimFacingScale(direction === "left" ? "right" : "left");
    return {
        "0%": { scale: outbound },
        "50%": { scale: outbound },
        "51%": { scale: inbound },
        "100%": { scale: inbound },
    };
}

export function generateFishAnimationKeyframes() {
    return {
        "0%": {
            "rotate": "y 20deg",
            "scale": "0.95"
        },
        "50%": {
            "rotate": "y 0deg",
            "scale": "1"
        },
        "100%": {
            "rotate": "y -20deg",
            "scale": "1.05"
        }
    };
}

export const MIN_FISH_WIDTH_PX = 130;
export const MAX_SWIM_SCALE = 1.45;

export function randomSwimScale(width) {
    const minScale = MIN_FISH_WIDTH_PX / width;
    return random(minScale, Math.max(minScale, MAX_SWIM_SCALE));
}

export { random };
